"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styles = require("@material-ui/core/styles");

var _theme = _interopRequireDefault(require("./theme"));

var _ButtonGroup = _interopRequireDefault(require("@material-ui/core/ButtonGroup"));

var _Button = _interopRequireDefault(require("@material-ui/core/Button"));

var _ArrowDropDown = _interopRequireDefault(require("@material-ui/icons/ArrowDropDown"));

var _ClickAwayListener = _interopRequireDefault(require("@material-ui/core/ClickAwayListener"));

var _Paper = _interopRequireDefault(require("@material-ui/core/Paper"));

var _Popper = _interopRequireDefault(require("@material-ui/core/Popper"));

var _MenuItem = _interopRequireDefault(require("@material-ui/core/MenuItem"));

var _MenuList = _interopRequireDefault(require("@material-ui/core/MenuList"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

const useStyles = (0, _styles.makeStyles)(theme => ({
  root: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    margin: theme.spacing(-0.5),
    "& > *": {
      margin: theme.spacing(0.5)
    }
  },
  buttongroup: {},
  button: {},
  dropdown: {}
}));

const EditComboButton = (_ref) => {
  let children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, ["children"]);

  const label = props.label;

  const _React$useState = _react.default.useState(false),
        open = _React$useState[0],
        setOpen = _React$useState[1];

  const anchorRef = _react.default.useRef(null);

  const handleClick = ({
    onClick
  }) => {
    setOpen(false);
    onClick && onClick();
  };

  const handleToggle = () => {
    setOpen(prevOpen => !prevOpen);
  };

  const handleClose = event => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  };

  const classes = useStyles();
  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_ButtonGroup.default, {
    variant: "outlined",
    ref: anchorRef,
    "aria-label": "edit"
  }, _react.default.createElement(_Button.default, {
    onClick: () => handleClick(props)
  }, label), _react.default.createElement(_Button.default, {
    size: "small",
    "aria-controls": open ? 'split-button-menu' : undefined,
    "aria-expanded": open ? 'true' : undefined,
    "aria-label": "select merge strategy",
    "aria-haspopup": "menu",
    onClick: handleToggle
  }, _react.default.createElement(_ArrowDropDown.default, null))), _react.default.createElement(_Popper.default, {
    open: open,
    anchorEl: anchorRef.current,
    role: undefined,
    transition: true,
    style: {
      zIndex: 2000
    }
  }, _react.default.createElement(_Paper.default, {
    square: true
  }, _react.default.createElement(_ClickAwayListener.default, {
    onClickAway: handleClose
  }, _react.default.createElement(_MenuList.default, {
    id: "split-button-menu"
  }, children.map((option, index) => {
    const label = option.label,
          disabled = option.disabled,
          selected = option.selected;
    return _react.default.createElement(_MenuItem.default, {
      key: index,
      disabled: disabled,
      selected: selected,
      onClick: () => handleClick(option)
    }, label);
  }))))));
};

const EditButton = ({
  label,
  onClick,
  children
}) => {
  const classes = useStyles();
  return _react.default.createElement(_Button.default, {
    variant: "outlined",
    onClick: onClick
  }, label);
};

const NavEdit = ({
  className,
  buttons = []
}) => {
  const classes = useStyles();
  return _react.default.createElement(_styles.ThemeProvider, {
    theme: _theme.default
  }, _react.default.createElement(_ButtonGroup.default, {
    className: className || classes.root
  }, buttons.map((button, index) => {
    if (button.children) {
      return _react.default.createElement(EditComboButton, _extends({}, button, {
        key: index
      }));
    }

    return _react.default.createElement(EditButton, _extends({}, button, {
      key: index
    }));
  })));
};

var _default = NavEdit;
exports.default = _default;
module.exports = exports.default;